import { useState } from 'react';
import * as Api from '../../../Api';

const useDistanceMatrix = () => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const api = '/api/';

    const fetchDistanceMatrix = async (origin, destination) => {

        setIsLoading(true);
        setError(null);

        try {
            const response = await Api.getRequest(`/googlemap/distance?origin=${origin}&destination=${destination}`, 'GET');
            setData(response);
            return response;
        } catch (err) {
            console.error('Error fetching distance matrix:', err);
            setError('Failed to fetch distance matrix data. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return { data, isLoading, error, fetchDistanceMatrix };
};

export default useDistanceMatrix;
